import React, { Component, useEffect } from "react";
import { Switch } from "react-router-dom";
import { connect } from "react-redux";
import io from "socket.io-client";
import { ToastContainer } from "react-toastify";
import { signInSocket } from "./config/TokenHelper";
import "react-toastify/dist/ReactToastify.css";

// Import Routes
import { authProtectedRoutes, publicRoutes } from "./routes/";
import AppRoute from "./routes/route";

// layouts
import VerticalLayout from "./components/VerticalLayout/";
// Redesigned operations console shell (design handoff, 31 screens).
import ConsoleLayout from "./components/Console/ConsoleLayout";
import HorizontalLayout from "./components/HorizontalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";

// Theme Provider
import { ThemeProvider } from "./context/ThemeContext";

// Loading Context and Logo Loader
import { LoadingProvider, useLoading } from "./context/LoadingContext";
import LogoLoader from "./components/LogoLoader";
import { setupAxiosInterceptors } from "./config/axiosConfig";

// Firebase helper
import { initFirebaseBackend } from "./helpers/firebase_helper";

// Import scss
import "./theme.scss";

// Firebase config
console.log("API URL --->", process.env.REACT_APP_DEFAULTAUTH);
const firebaseConfig = {
  apiKey: process.env.REACT_APP_APIKEY,
  authDomain: process.env.REACT_APP_AUTHDOMAIN,
  databaseURL: process.env.REACT_APP_DATABASEURL,
  projectId: process.env.REACT_APP_PROJECTID,
  storageBucket: process.env.REACT_APP_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
  appId: process.env.REACT_APP_APPID,
  measurementId: process.env.REACT_APP_MEASUREMENTID,
};

// init firebase backend
initFirebaseBackend(firebaseConfig);

// Component to setup axios interceptors with loading context
const AxiosInterceptorSetup = ({ children }) => {
  const { showLoading, hideLoading } = useLoading();

  useEffect(() => {
    setupAxiosInterceptors(showLoading, hideLoading);
  }, [showLoading, hideLoading]);

  return children;
};

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.getLayout = this.getLayout.bind(this);
  }

  componentDidMount() {
    // Auth check
    const authToken = localStorage.getItem("token");
    const authkey = localStorage.getItem("authkey");

    if (authToken && authkey) {
      if (window.location.pathname === "/login") window.location.href = "/";
    } else {
      if (window.location.pathname === "/") window.location.href = "/login";
    }

    // Scroll to the top of the page
    window.scrollTo(0, 0);

    // Initialize the WebSocket connection only if logged in
    if (authToken && authkey) {
      const SERVER = process.env.REACT_APP_SOCKET_URL || "http://localhost:5001";
      this.socket = io.connect(SERVER, { secure: true });

      // Sign the socket in with the API credentials, on every (re)connect.
      signInSocket(this.socket);

      // Handle socket events here
      this.socket.on("connect", () => {
        console.log("Socket Connected, socket.id:", this.socket.id);
      });

      this.socket.on("connected", () => {
        console.log("Socket Registered Successfully");
      });

      // Notification toasts are handled by NotificationDropdown via SocketComponent
      // Only log here for debugging
      this.socket.on("new-notification-received", (data) => {
        console.log("New Notification Received (App.js):", data);
      });

      this.socket.on("disconnect", () => {
        console.log("Socket Disconnected");
      });

      this.socket.on("connect_error", (error) => {
        console.error("Socket Connection Error:", error);
      });
    }
  }

  componentWillUnmount() {
    if (this.socket) {
      this.socket.disconnect();
    }
  }

  getLayout = () => {
    // The console redesign replaces the template chrome for authenticated
    // screens. VerticalLayout/HorizontalLayout are kept so the switch can be
    // reverted in one line if a screen still needs the old shell.
    switch (this.props.layout.layoutType) {
      case "horizontal":
        return HorizontalLayout;
      case "legacy":
        return VerticalLayout;
      default:
        return ConsoleLayout;
    }
  };

  render() {
    const Layout = this.getLayout();

    return (
      <ThemeProvider>
        <LoadingProvider>
          <AxiosInterceptorSetup>
            <LogoLoader />
              <Switch>
                {publicRoutes.map((route, idx) => (
                  <AppRoute
                    path={route.path}
                    layout={NonAuthLayout}
                    component={route.component}
                    key={idx}
                    isAuthProtected={false}
                  />
                ))}

                {authProtectedRoutes.map((route, idx) => (
                  <AppRoute
                    path={route.path}
                    layout={Layout}
                    component={route.component}
                    key={idx}
                    isAuthProtected={true}
                  />
                ))}
              </Switch>
            {/* The ONE toast container for the whole app. Pages must not mount
                their own - 47 of them used to, so every toast appeared twice,
                once here and once from the page. autoClose was false, so the
                duplicates also never went away. */}
            <ToastContainer
              position="top-right"
              autoClose={5000}
              newestOnTop
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="colored"
            />
          </AxiosInterceptorSetup>
        </LoadingProvider>
      </ThemeProvider>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    layout: state.Layout,
  };
};

export default connect(mapStateToProps, null)(App);
